import { ContractAction, ContractState } from "./types";

export const setContractRecord = (payload: Partial<ContractState>) =>
  ({
    type: ContractAction.SET_CONTRACT_RECORD,
    payload,
  }) as const;

export const cancelContract = (planId: string, payload, callback: () => void) =>
  ({
    type: ContractAction.CANCEL_CONTRACT,
    planId,
    payload,
    callback,
  }) as const;

export const getContractRecord = (payload: string) =>
  ({
    type: ContractAction.GET_CONTRACT_RECORD,
    payload,
  }) as const;

export const cleanUpContract = () =>
  ({
    type: ContractAction.CLEAN_UP,
  }) as const;

export const calculateRefundAmount = () =>
  ({
    type: ContractAction.CANCEL_CONTRACT_AMOUNT_CLACULATE,
  }) as const;

export const sendEmail = (payload = {}, callBack = () => {}) =>
  ({
    type: ContractAction.CLAIM_FILE_SEND_EMAIL,
    payload,
    callBack,
  }) as const;

export const submitContractTicket = (payload = {}, callBack = () => {}) =>
  ({
    type: ContractAction.SUBMIT_TICKET,
    payload,
    callBack,
  }) as const;
